import {Sport1MaterialTabs} from "../components/material-tabs";
import {WPApi} from "../common/wp-api";

const api = new WPApi();

let categoriesContentCache = {};

jQuery(document).ready(($) => {

    const tabs = new Sport1MaterialTabs('.material-tabs');

    tabs._onTabClick = async (e, $activeTab) => {

        let $content = $(`.tab-content > .row`);
        let categoryId = $activeTab.attr('id');

        let category = $activeTab.text().trim();


        sport1Analytics.sendEvent('internal-vod-page', 'tabs-click', category);

        if (!categoriesContentCache[categoryId]) {

            if (categoryId === 'all') {
                categoryId = pageGlobals.object_id;
            }

            categoriesContentCache[categoryId] = await getVideosByCategory(categoryId);
        }

        $content.html(categoriesContentCache[categoryId]);
        lazyLoader.update();

        return false;
    };

    $('.video-card .post-link').on('click', function () {
        let video = $('.title-text').text().trim();
        sport1Analytics.sendEvent('internal-vod-page', 'play', video);
    });

});

async function getVideosByCategory(categoryId) {

    let response = await api.get('wp/v2/vod/category/' + categoryId);


    return response.content;

}